import { render } from "./PlanEdit.vue?vue&type=template&id=d4cf5d2e&scoped=true"
import script from "./PlanEdit.vue?vue&type=script&lang=js"
export * from "./PlanEdit.vue?vue&type=script&lang=js"

import "./PlanEdit.vue?vue&type=style&index=0&id=d4cf5d2e&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4cf5d2e"]])

export default __exports__